import { set, size, uniqBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchReservationAvailableEvents } from '../../sagas/routines';
import { clearReservationAvailableEvents } from '../../actions/available-events';

const initialState = {
  all: [],
  meta: { page: 1, count: 0 },
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchEventsHandler = routine => ({
  [routine.REQUEST]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: uniqBy('id', [...state.all, ...response.items]),
    meta: { ...response.meta, count: size(response.items) }
  }),
  [routine.FAILURE]: (state, { payload: error }) =>
    set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const clearReservationAvailableEventsHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchEventsHandler(fetchReservationAvailableEvents),
  ...clearReservationAvailableEventsHandler(clearReservationAvailableEvents)
});
